// src/features/staff/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import StaffListPage from './pages/StaffListPage';
import CreateStaffPage from './pages/CreateStaffPage';
import StaffDetailsPage from './pages/StaffDetailsPage/StaffDetailsPage';
import EditStaffPage from './pages/EditStaffPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';

export const StaffRoutes = () => (
  <>
    <Route path="staff">
      <Route
        index
        element={
          <ProtectedRoute requiredScope="staff:read">
            <StaffListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute requiredScope="staff:create">
            <CreateStaffPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":staffId"
        element={
          <ProtectedRoute requiredScope="staff:read">
            <StaffDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":staffId/edit"
        element={
          <ProtectedRoute requiredScope="staff:update">
            <EditStaffPage />
          </ProtectedRoute>
        }
      />
    </Route>
    <Route
      path="profile"
      element={
        <ProfilePage />
      }
    />
  </>
);